/* eslint-disable no-param-reassign */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { IFilterSelectSearchProps, TOptionsItem } from '../types';
import { highlightText } from '../utils';

const useFilterSearch = (props: IFilterSelectSearchProps) => {
  const {
    searchValue: propsSearchValue,
    onSearchValueChange,
    options,
    radioOptions,
  } = props || {};
  const [searchValue, setSearchValue] = useState('');

  // 外部受控searchValue
  useEffect(() => {
    propsSearchValue && setSearchValue(propsSearchValue);
  }, [propsSearchValue]);

  // 搜索change事件
  const handleSearchValueChange = (searchValue: string) => {
    setSearchValue(searchValue);
    onSearchValueChange?.(searchValue);
  };

  // 搜索高亮
  const replaceMatch = useCallback(
    (text: string, _searchValue = searchValue) =>
      highlightText(text, _searchValue),
    [searchValue],
  );

  // 根据搜索结果渲染的options函数
  const matchOptions = useCallback(
    (list: Array<TOptionsItem>) => {
      const matchOptionList: Array<TOptionsItem> = [];
      list?.forEach((optionItem: TOptionsItem) => {
        const filterText = replaceMatch(optionItem?.text);

        // 分组匹配逻辑：是否匹配到分组
        // let isFilterGroup = false;
        // if (group) {
        //   isFilterGroup = replaceMatch(group?.[optionItem?.[groupByKey]])?.includes('</span>');
        // }

        // 过滤掉不包含 searchValue 的项, 且匹配不到分组
        if (optionItem?.text === filterText) return;
        const item = {
          ...optionItem,
          text: filterText,
        };

        matchOptionList?.push(item);
      });
      return matchOptionList;
    },
    [replaceMatch],
  );

  // 根据搜索结果渲染的options radioOptions
  const { renderOptions, renderRadioOptions } = useMemo(() => {
    // 无 searchValue 展示全部
    if (!searchValue)
      return { renderOptions: options, renderRadioOptions: radioOptions };
    const renderOptions: Array<TOptionsItem> = matchOptions(options);
    const renderRadioOptions: Array<TOptionsItem> = matchOptions(radioOptions);
    return { renderOptions, renderRadioOptions };
  }, [matchOptions, options, radioOptions, searchValue]);

  return {
    searchValue,
    renderOptions,
    renderRadioOptions,
    setSearchValue,
    replaceMatch,
    handleSearchValueChange,
  };
};

export default useFilterSearch;
